module.exports = __webpack_public_path__ + "Expenses.5b163357a0bb0a3d9c86.png";